






/**
 * frontend-ibow-reactによるReactアプリを動作するためのコンポーネント
 * frontend-ibowとfrontend-ibow-react側で同じRouteのパスを設定することでReactアプリを動作させる
 * Vue側のCSSとReact側のCSSが競合しないように、Shadow DOM内でReactアプリを動作させる
 */

import { Component, Mixins, Ref } from "vue-property-decorator";

@Component
export default class FrontendIBowReact extends Mixins() {
  @Ref("frontendIBowReactWrapper")
  private frontendIBowReactWrapper!: HTMLElement;

  mounted() {
    this.injectReactAppScript();
  }

  beforeDestroy() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const win: any = window as any;
    if (typeof win.frontendIBowReactUnmount === "function") {
      win.frontendIBowReactUnmount();
    }
  }

  /**
   * Append the React bundle script once, async. If it already exists, do nothing.
   */
  private injectReactAppScript() {
    const host = this.frontendIBowReactWrapper;
    const shadow = host.shadowRoot || host.attachShadow({ mode: "open" });
    if (!shadow) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const appVersionHash = (window as any).app_version_hash;

    // Inject CSS into ShadowRoot (once)
    fetch(`/frontend-ibow-react-dist/assets/index.css?v=${appVersionHash}`)
      .then(res => res.text())
      .then(cssText => {
        // 1) ShadowRoot には従来どおり全CSSを適用
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cssStyleSheet: any = new (CSSStyleSheet as any)();
        cssStyleSheet.replaceSync(cssText);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (shadow as any).adoptedStyleSheets.push(cssStyleSheet);

        // 2) document 側には @property だけを適用（登録のため）
        try {
          const propertyBlocks =
            cssText.match(/@property\s+[^{}]+\{[^}]*\}/g) || [];
          if (propertyBlocks.length) {
            const propsCSS = propertyBlocks.join("\n");
            // 重複注入防止（グローバルフラグ）
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const win: any = window as any;
            if (!win.__ibowReactPropsInjected) {
              win.__ibowReactPropsInjected = true;
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              if ((document as any).adoptedStyleSheets) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const propSheet: any = new (CSSStyleSheet as any)();
                propSheet.replaceSync(propsCSS);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (document as any).adoptedStyleSheets = [
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ...(document as any).adoptedStyleSheets,
                  propSheet
                ];
              }
            }
          }
        } catch (e) {
          console.warn("@property 注入に失敗しました", e);
        }

        let div = shadow.getElementById("frontend-ibow-react");
        if (!div) {
          div = document.createElement("div");
          div.id = "frontend-ibow-react";
          shadow.append(div);
        }

        const existing = document.querySelector(
          'script[data-react-app="frontend-ibow-react"]'
        );

        if (!existing) {
          const script = document.createElement("script");
          script.src = `/frontend-ibow-react-dist/index.js?v=${appVersionHash}`;
          script.async = true;
          script.type = "module";
          script.crossOrigin = "anonymous";
          script.setAttribute("data-react-app", "frontend-ibow-react");
          script.onload = () => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const win: any = window as any;
            if (typeof win.frontendIBowReactBootstrap === "function") {
              win.frontendIBowReactBootstrap(shadow);
            } else {
              // fallback retry
              setTimeout(() => win.frontendIBowReactBootstrap?.(shadow), 0);
            }
          };
          document.head.appendChild(script);
        } else {
          // Already loaded, just bootstrap
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (window as any).frontendIBowReactBootstrap?.(shadow);
        }
      });
  }
}
